import { parse, format } from 'date-fns';

declare global{
    interface String{
        isNullorEmpty():boolean;
        toFormatYYYYMMD():string;
    }
}
String.prototype.isNullorEmpty=function():boolean{
    
    if(this == null) return true;
    if(this.trim().length===0) return true;
    
    return false;
}

String.prototype.toFormatYYYYMMD=function() : string {

    // const newStr:string = 
   return  format(!this.isNullorEmpty()?new Date(this.toString()):new Date(),'yyyy-MM-dd')
    // return newStr;
}

export function convertirFormatoFecha(cadenaFecha: string): string {
    // Parsear la cadena de fecha en un objeto Date
    const fecha = parse(cadenaFecha, 'dd/MM/yyyy hh:mm:ss a', new Date());
  
    // Formatear la fecha en el formato deseado "yyyy/MM/dd"
    const fechaFormateada = format(fecha, 'yyyy-MM-dd');
  
    return fechaFormateada;
}

